// extracted by mini-css-extract-plugin
module.exports = {"tableCont":"history_tableCont__1GrUl"};